export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const LANDING = {
  navbar: 'landing-navbar',
  logo: 'landing-logo',
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',
  problemSection: 'problem-section',
  howItWorksSection: 'how-it-works-section',
  featuresSection: 'features-section',
  benefitsSection: 'benefits-section',
  pricingSection: 'pricing-section',
  pricingFixedCard: 'pricing-fixed-card',
  pricingVariableCard: 'pricing-variable-card',
  footerCta: 'footer-cta',
};
